(() => {
  if (window.eqCollectionViews) return;
  window.eqCollectionViews = true;
  const key = 'eclectique.collection.columns';
  let selected = '4';
  try { if (localStorage.getItem(key) === '8') selected = '8'; } catch (_) {}
  const sync = () => {
    document.querySelectorAll('[data-section-type="collection"]').forEach(section => {
      section.dataset.eqView = selected;
      section.querySelectorAll('[data-eq-columns]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.eqColumns === selected));
      });
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-eq-columns]');
    if (!button || !button.closest('[data-section-type="collection"]')) return;
    selected = button.dataset.eqColumns === '8' ? '8' : '4';
    try { localStorage.setItem(key, selected); } catch (_) {}
    sync();
    window.dispatchEvent(new Event('resize'));
  });
  sync();
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-eq-columns], [data-section-type="collection"]') || node.querySelector('[data-eq-columns], [data-section-type="collection"]'))))) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', sync);
  window.addEventListener('pageshow', sync);
})();
